import { AuctionNotice } from '../Interfaces/auctionNotice';

const getCompetentAuthorityName = (auction: AuctionNotice) => {
    return (
        auction?.auctionTypeRules?.generalSettings?.comissao?.operacional?.descricao ?? 'Pregoeiro'
    );
};

export { getCompetentAuthorityName };
